import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

/* MobX */
// import { observer } from 'mobx-react-lite';

/* MUI */
import { makeStyles } from '@material-ui/core/styles';
import { Button, Container, FormControl, Grid, Paper, TextField, Typography } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';

import { searchAppeals } from '../../services/APIClient';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: "20px",
  },
  buttonSubmit: {
    // // marginBottom: 10,
    // margin: theme.spacing(1),
    // height: "75%"
    height: "56px"
  },
  table: {
    marginTop: "20px",
    '& .MuiDataGrid-colCell': {
      backgroundColor: '#115293',
      color: theme.palette.common.white,
      fontSize: 14
    },
    '& .MuiDataGrid-row': {
      '&:hover': {
        backgroundColor: '#fffbf2',
        cursor: 'pointer'
      },
    }
  },
}));

const SearchAppeal = props => {
  const classes = useStyles();
  let navigate = useNavigate();

  const [customerAppealId, setCustomerAppealId] = useState({ CustomerAppealId: "" });
  // const [appealType, setAppealType] = useState("");
  // const [appealId, setAppealId] = useState("");
  const [account, setAccount] = useState({ AccountNumber: "" });
  const [results, setResults] = useState([]);
  const [appealIdError, setAppealIdError] = useState(false);
  const [accountError, setAccountError] = useState(false);

  const getReviewURL = (row) => {
    switch (row.appealType) {
      case 'Legal Owner':
        return `/appeals/review/incorrectowner/${row.customerAppealID}`;
      case 'Impermeable Area':
        return `/appeals/review/impermeablearea/${row.customerAppealID}`;
      case 'Excluded Area':
        return `/appeals/review/excludedarea/${row.customerAppealID}`;
      case 'Charge Allocations':
        return `/appeals/review/serviceagreement/${row.customerAppealID}`;
      default:
        return null;
    }
  };

  const compare = ( a, b ) => {
    if ( a.appealedDate.substring(0, 10) > b.appealedDate.substring(0, 10) ) {
      return -1;
    } else if ( a.appealedDate.substring(0, 10) < b.appealedDate.substring(0, 10) ) {
      return 1;
    } else {
      if (a.reviewerDecision  === "Pending" ) {
        return -1;
      } else if (b.reviewerDecision  === "Pending") {
        return 1;
      } else if (a.reviewerDecision < b.reviewerDecision) {
        return -1
      } else if (a.reviewerDecision > b.reviewerDecision) {
        return 1
      } else {
        return 0
      }
    }
  }

  const formatAppealType = (appeal) => {
    switch (appeal.appealType) {
      case 'LegalOwner':
        return 'Legal Owner';
      case 'ImpermeableArea':
        return 'Impermeable Area';
      case 'ExcludedArea':
        return 'Excluded Area';
      case 'ChargeAllocations':
        return 'Charge Allocations';
      default:
        return '';
    }
  };
  
  const queryAppeals = (params) => {
    searchAppeals(params)
      .then((response) => {
        if (response && response.data) {
          //console.log("appeal results", response.data)
          response.data.map((appeal) => {
            appeal.appealType = formatAppealType(appeal);
          })
          setResults(response.data.sort( compare ));
        } else {
          setResults([])
        }
      })
      .catch((e) => {
        if ('AccountNumber' in params) {
          setAccountError(true);
        }
        if ('CustomerAppealId' in params) {
          setAppealIdError(true);
        }
        //console.log(e)
        setResults([])
      })
  };

  const searchByCustomerAppealId = () => {
    queryAppeals(customerAppealId);
  };

  // const searchByType = () => {
  //   const params = {
  //     AppealType: appealType,
  //     AppealId: appealId
  //   }
  //   queryAppeals(params);
  // };

  const searchByAccount = () => {
    queryAppeals(account);
  };

  const header = [
    {
      field: 'customerAppealID',
      headerName: 'SDMS Appeal ID',
      width: 210,
      renderCell: (params) => {
        const onClick = () => {
          const url = getReviewURL(params.row);
          navigate(url);
        };
        return <Button size="small" color="primary" onClick={onClick}>{params.value}</Button>;
      }
    },
    { field: 'appealType', headerName: 'Appeal Type', width: 180 },
    { field: 'accountNumber', headerName: 'Account', width: 140 },
    { field: 'reviewerDecision', headerName: 'Decision', width: 140 },
    {
      field: 'appealedDate',
      headerName: 'Appealed Date',
      width: 180,
      valueFormatter: (params) => {
        return params.value?.substring(0, 10);
      },
    },
    {
      field: 'statusChangedDate',
      headerName: 'Status Change Date',
      width: 220,
      valueFormatter: (params) => {
        return params.value?.substring(0, 10);
      },
    },
    { field: 'reviewSubmittedBy', headerName: 'Reviewed By', width: 180 },
  ];

  const handleFormSubmit = (event) => {
    if (event.target.name === 'CustomerAppealId' && event.key === 'Enter') {
      searchByCustomerAppealId();
    } else if (event.target.name === 'AccountNumber' && event.key === 'Enter') {
      searchByAccount();
    }
  }

  return (
    <Container maxWidth="md">
      <Paper className={classes.paper}>
        <Typography variant="h6">Appeals Search </Typography>
        {/* <form autoComplete="off" noValidate className={classes.form} onSubmit={appealsHandleSubmit}> */}
        <FormControl fullWidth margin='dense' onKeyPress={handleFormSubmit}>
        <Grid container spacing={1} className={classes.form}>
          {/* Search by Customer Appeal ID */}
          <Grid item xs={10}>
            <TextField
              name="CustomerAppealId"
              variant="outlined"
              label="SDMS Appeal ID (Example: 60)"
              type="search"
              error={appealIdError}
              helperText={appealIdError ? 'The appeal is not found.' : ''}
              fullWidth
              value={customerAppealId.CustomerAppealId}
              onChange={(e) => {
                setCustomerAppealId({ [e.target.name]: e.target.value });
                setAppealIdError(false);
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <Button
              className={classes.buttonSubmit}
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              fullWidth
              onClick={searchByCustomerAppealId}
              disabled={customerAppealId.CustomerAppealId ? false : true}
            >
              Submit
            </Button>
          </Grid>

          {/* Search by Appeal Type and Appeal ID */}
          {/* <Grid item xs={5}>
            <FormControl variant="outlined" fullWidth className={classes.select}>
              <InputLabel htmlFor="appeal_Type">Appeal Type</InputLabel>
              <Select value={appealType} onChange={(e) => setAppealType(e.target.value)}>
                <option value=""></option>
                <option value="LegalOwner">Legal Owner</option>
                <option value="ImpermeableArea">Impermeable Area</option>
                <option value="ExcludedArea">Excluded Area</option>
                <option value="ChargeAllocations">SA Distribution</option>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={5}>
            <TextField
              name="AppealId"
              variant="outlined"
              label="Appeal ID"
              type="search"
              fullWidth
              value={appealId}
              onChange={(e) => setAppealId(e.target.value)}
            />
          </Grid>
          <Grid item xs={2}>
            <Button
              className={classes.buttonSubmit}
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              fullWidth
              onClick={searchByType}
              disabled={appealType && appealId ? false : true}
            >
              Submit
            </Button>
          </Grid> */}

          {/* Search by Account NO */}
          <Grid item xs={10}>
            <TextField
              name="AccountNumber"
              variant="outlined"
              label="Account No (Example: 2690300000)"
              type="search"
              fullWidth
              error={accountError}
              helperText={accountError ? 'The records are not found.': ''}
              value={account.AccountNumber}
              onChange={(e) => {
                setAccount({ [e.target.name]: e.target.value });
                setAccountError(false)
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <Button
              className={classes.buttonSubmit}
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              fullWidth
              onClick={searchByAccount}
              disabled={account.AccountNumber ? false : true}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
        </FormControl>

        {results.length > 0 && <DataGrid
          className={classes.table}
          columns={header}
          rows={results}
          getRowId={(row) => row.appealId}
          autoHeight
          autoPageSize={true}
        />}
        {/* </form > */}
      </Paper >
    </Container>
  )
};

export default SearchAppeal;